module.exports = __webpack_public_path__ + "img/resource-ys-active.2b54f6a4.png";